module.exports = __webpack_public_path__ + "static/media/rightArrowDisabled.ce5769c6.svg";